export default function miToKm(value: number): number {
  return +(value * 1.609344).toFixed(3)
}
